import { Component, OnInit } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ReportingProfessionnelService } from '../core/service/reporting-professionnel.service';

@Component({
  selector: 'app-extraction-professionnel',
  templateUrl: './extraction-professionnel.component.html',
  styleUrls: ['./extraction-professionnel.component.scss']
})
export class ExtractionProfessionnelComponent implements OnInit {

  debut: any = null;
  fin: any = null;

  constructor(
    private datePipe: DatePipe,
    private _reportingService: ReportingProfessionnelService
  ) {}

  ngOnInit() {}

  exportDossiers() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService.exportDossiers(deb, fn).subscribe((blob) => {
      let fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", "dossiers-" + deb + ".xlsx");
      document.body.appendChild(link);
      link.click();
    });
  }

}
